import { TriangleAlertIcon } from "lucide-react";
import {
  Alert,
  AlertDescription,
  AlertTitle,
} from "@/shared/components/ui/alert";

export function MatrixCompatibilityCard({ rowCount }: { rowCount: number }) {
  return (
    <Alert>
      <TriangleAlertIcon />
      <AlertTitle>Matrix rows are incompatible</AlertTitle>
      <AlertDescription>
        The Matrix structure changed.{" "}
        {rowCount === 1
          ? "One row no longer matches"
          : `${rowCount} rows no longer match`}{" "}
        this Matrix. No data was changed. Open the affected reports to review
        their structure, then retry, or switch to another matrix.
      </AlertDescription>
    </Alert>
  );
}
